import { useState } from 'react';
import { Trans } from '@lingui/macro';
import { TableBodyCell, IconButton, Menu, MenuBody, MenuList, MenuItem } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useApi } from 'app/domains/api-management';
export function KeyContextCell(props) {
    const { id } = props;
    const { setDialog } = useApi();
    const [open, setOpen] = useState(false);
    const handleOpen = (dialog) => {
        setOpen(false);
        setDialog({ type: dialog, id });
    };
    return (<TableBodyCell headers="edit" stickyColumn="right">
      <Menu onClose={() => setOpen(false)} open={open} target={<IconButton $round size="small" appearance="ghost" onClick={() => setOpen(!open)}>
            <Falcon icon="ellipsis-vertical"/>
          </IconButton>}>
        <MenuBody>
          <MenuList>
            <MenuItem onClick={() => handleOpen('view')}>
              <Falcon icon="eye"/>
              <Trans comment="Key Table - View">View</Trans>
            </MenuItem>
            <MenuItem onClick={() => handleOpen('edit')}>
              <Falcon icon="pen"/>
              <Trans comment="Key Table - Edit">Edit</Trans>
            </MenuItem>
            <MenuItem onClick={() => handleOpen('delete')}>
              <Falcon icon="trash"/>
              <Trans comment="Key Table - Delete">Delete</Trans>
            </MenuItem>
          </MenuList>
        </MenuBody>
      </Menu>
    </TableBodyCell>);
}
